import classNames from 'classnames';

import { ImageFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import { Paragraph } from '../../../components/Text';

import sectionStyle from '../../../layout/Section/section.module.css';
import style from './testimonial.module.css';

interface TestimonialProps {
  author: string;
  authorImage?: ImageFragmentFragment | null;
  current: boolean;
  quote: string;
  transformFromRight: boolean | null;
  withSectionTitleStyle: boolean;
}

const Testimonial = ({
  author,
  authorImage,
  current,
  quote,
  transformFromRight,
  withSectionTitleStyle,
}: TestimonialProps) => {
  return (
    <article
      className={classNames(
        style.testimonial,
        {
          [style.current]: current,
          [style.toNext]: transformFromRight,
          [style.toPrevious]: transformFromRight === false,
        },
      )}
    >
      {authorImage && (
        <AppImage
          className={style.authorHeadshot}
          fallbackHeight={289}
          fallbackWidth={289}
          image={authorImage}
        />
      )}

      <blockquote className={style.quote}>
        <Paragraph
          className={classNames({ [sectionStyle.sectionTitle]: withSectionTitleStyle })}
          fontSize={withSectionTitleStyle ? 30 : 24}
          fontWeight={300}
        >
          &quot;
          {quote}
          &quot;
        </Paragraph>
      </blockquote>

      <cite className={style.author}>
        <Paragraph fontWeight={700}>
          {author}
        </Paragraph>
      </cite>
    </article>
  );
};

export default Testimonial;
